import React, { PropsWithChildren } from 'react';
import { Paper } from '@mui/material';
import { blue, grey } from '@mui/material/colors';

export const StyledContainer = ({ children }: PropsWithChildren<{}>) => (
  <Paper
    sx={({ palette }) => ({
      gap: '1rem',
      display: 'grid',
      padding: '1rem 1.5rem',
      gridTemplateRows: 'auto auto',

      '& .managerHeader': {
        gap: '1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      },

      '& .managerDetails': {
        gap: '0.5rem',
        display: 'grid',
        gridTemplateRows: 'auto 1fr',

        '& .stagesList': {
          gap: '0.25rem',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'flex-start',

          '& .stageBadge': {
            gap: '0.25rem',
            display: 'flex',
            padding: '4px 8px',
            cursor: 'pointer',
            alignItems: 'center',
            borderRadius: '0.25rem',

            '&:hover': {
              cursor: 'pointer',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
            },
          },

          '& .stage-passed': {
            backgroundColor: grey[50],
            border: `1px solid ${grey[300]}`,
          },

          '& .stage-current': {
            backgroundColor: blue[50],
            border: `1px solid ${palette.primary.main}`,
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
          },

          '& .stage-future': {
            backgroundColor: blue[50],
            border: `1px solid ${palette.primary.main}`,
          },

          '& .stage-viewed': {
            backgroundColor: grey[50],
            border: `1px solid ${palette.primary.main}`,
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
          },
        },

        '& .attributesLayout': {
          gap: '1rem',
          display: 'grid',
          gridTemplateRows: 'auto auto',

          '& .attributesHeader': {
            gap: '1rem',
            display: 'grid',
            gridTemplateColumns: 'auto 350px',

            '& .labelWithWarning': {
              gap: '0.25rem',
              display: 'flex',
              alignSelf: 'center',

              '& svg': {
                fontSize: 18,
                transformOrigin: 'center',
                animation: 'pulseScale 1.5s infinite ease-in-out',
              },

              '@keyframes pulseScale': {
                '0%, 100%': { transform: 'scale(1)' },
                '50%': { transform: 'scale(1.1)' },
              },
            },
          },

          '& .attributes': {
            gap: '0.25rem',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',

            '& .attribute': {
              height: '6rem',
              padding: '0.5rem',
              overflowY: 'auto',
              borderRadius: '0.25rem',
              backgroundColor: grey[50],
              border: `1px solid ${grey[300]}`,
            },

            '& .attribute-loading': {
              position: 'relative',
              overflow: 'hidden',
              backgroundColor: grey[50],
              '&::after': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                animation: 'shimmer 1.5s infinite',
                background: `linear-gradient(90deg, transparent, ${grey[200]}, transparent)`,
              },

              '@keyframes shimmer': {
                '0%': {
                  transform: 'translateX(-100%)',
                },
                '100%': {
                  transform: 'translateX(100%)',
                },
              },
            },
          },
        },
      },
    })}
  >
    {children}
  </Paper>
);
